<template>

	<div class="abow_wbox bkf7">
		<div class="inter">
			<div class="n_content_ti"><span>帮助中心</span> </div>
			<div class="de_content_box">
				<div class="help-content">
					<div class="help-section" v-for="(section, index) in helpSections" :key="index">
						<div class="help-section-title">
							<i :class="section.icon"></i>
							<span>{{ section.title }}</span>
						</div>
						<div class="help-section-content">
							<div class="help-item" v-for="(item, idx) in section.items" :key="idx">
								<div class="help-q" @click="toggleItem(index, idx)" :class="{ 'active': activeItem[index] === idx }">
									<i class="el-icon-question"></i>
									<span>{{ item.q }}</span>
									<i class="el-icon-arrow-down arrow" :class="{ 'up': activeItem[index] === idx }"></i>
								</div>
								<div class="help-a" v-show="activeItem[index] === idx">
									<p v-html="item.a"></p>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

</template>


<script>
export default {
	data() {
		return {
			activeItem: {},
			helpSections: [
				{
					title: '租号流程',
					icon: 'el-icon-s-order',
					items: [
						{
							q: '如何租用账号？',
							a: '1.浏览商品：在首页或分类页面浏览您想要的账号<br>2.选择账号：点击您心仪的账号查看详情<br>3.提交订单：选择租期后点击"立即租用"<br>4.获取账号：支付租金后即可查看账号密码<br>5.开始游戏：使用提供的账号信息登录游戏'
						},
						{
							q: '租号需要支付哪些费用？',
							a: '租金费用：根据您选择的租期和账号定价计算<br>押金费用：部分高价值账号需要支付押金，账号归还后自动退还<br>租金支付方式：微信、支付宝等在线支付'
						},
						{
							q: '账号租金如何计算？',
							a: '租金 = 账号日租金 × 租期天数<br>例如：账号日租金为10元，租期3天，总租金为30元<br>部分账号支持按小时计费，具体以页面显示为准'
						}
					]
				},
				{
					title: '账号使用',
					icon: 'el-icon-user',
					items: [
						{
							q: '租到的账号可以改密码吗？',
							a: '不可以。为保障账号安全，租用期间禁止修改账号密码、绑定信息等。违规操作导致账号被封禁，责任由租客自行承担。'
						},
						{
							q: '游戏过程中账号被顶下线怎么办？',
							a: '请立即联系客服处理。正常情况下，账号被顶下线可能是原号主找回账号，我们会第一时间为您处理或退款。'
						},
						{
							q: '账号登录失败怎么办？',
							a: '1.检查账号密码是否输入正确<br>2.确认游戏区服是否选择正确<br>3.尝试重启游戏或客户端<br>4.如仍无法登录，请联系客服协助处理'
						}
					]
				},
				{
					title: '押金与退款',
					icon: 'el-icon-wallet',
					items: [
						{
							q: '押金什么时候退还？',
							a: '押金将在您归还账号并确认账号无异常后自动退还。退款时间：微信支付1-3个工作日到账，支付宝即时到账。'
						},
						{
							q: '什么情况下押金会扣除？',
							a: '1.账号密码被修改导致无法使用<br>2.账号被封禁或冻结<br>3.恶意毁坏账号数据或装备<br>4.违反游戏协议导致账号异常'
						},
						{
							q: '租金可以退款吗？',
							a: '未使用的租期可以申请退款，需扣除已使用天数的租金。已使用时间不足24小时按24小时计算。申请退款请联系客服处理。'
						}
					]
				},
				{
					title: '售后与客服',
					icon: 'el-icon-service',
					items: [
						{
							q: '如何联系客服？',
							a: '1.点击页面右下角在线客服<br>2.添加客服微信：见页面底部联系方式<br>3.工作时间：周一至周日 0:00-23:59'
						},
						{
							q: '账号有问题可以获得赔偿吗？',
							a: '因账号本身问题（如原号主找回、账号被封等）导致无法正常使用的，我们提供全额退款或更换账号服务。因租客个人操作导致的异常不在赔偿范围内。'
						},
						{
							q: '投诉建议如何提交？',
							a: '您可以通过以下方式提交投诉建议：<br>1.联系在线客服反馈<br>2.添加客服微信进行反馈<br>3.我们重视每一位用户的反馈，会在24小时内处理'
						}
					]
				},
				{
					title: '账户安全',
					icon: 'el-icon-lock',
					items: [
						{
							q: '租号是否安全？',
							a: '我们平台采用多重安全措施保障交易安全：<br>1.账号租金由平台托管，确认收货后才释放给商家<br>2.严格的商家入驻审核机制<br>3.完善的纠纷处理机制<br>4.24小时客服在线'
						},
						{
							q: '我的账户信息会泄露吗？',
							a: '不会。我们平台非常重视用户隐私保护：<br>1.您的账户信息仅用于交易必要的联系<br>2.不会向第三方泄露用户信息<br>3.所有交易数据采用加密传输<br>4.定期进行安全检测'
						}
					]
				}
			]
		}
	},
	created: function () {
		
	},
	methods: {
		toggleItem(sectionIndex, itemIndex) {
			if (this.activeItem[sectionIndex] === itemIndex) {
				this.$set(this.activeItem, sectionIndex, null);
			} else {
				this.$set(this.activeItem, sectionIndex, itemIndex);
			}
		}
	}
}
</script>

<style scoped>
.help-content {
	padding: 20px;
}
.help-section {
	margin-bottom: 30px;
}
.help-section-title {
	display: flex;
	align-items: center;
	font-size: 18px;
	font-weight: bold;
	color: #333;
	margin-bottom: 15px;
	padding-bottom: 10px;
	border-bottom: 1px solid #eee;
}
.help-section-title i {
	font-size: 20px;
	color: #1f9535;
	margin-right: 8px;
}
.help-item {
	margin-bottom: 10px;
	border: 1px solid #eee;
	border-radius: 6px;
	overflow: hidden;
}
.help-q {
	display: flex;
	align-items: center;
	padding: 14px 15px;
	background: #f5f7fa;
	cursor: pointer;
	transition: all 0.3s;
}
.help-q:hover {
	background: #e8f5e9;
}
.help-q.active {
	background: #e8f5e9;
	border-bottom: 1px solid #eee;
}
.help-q i {
	color: #1f9535;
	margin-right: 8px;
}
.help-q span {
	flex: 1;
	font-size: 14px;
	color: #333;
}
.help-q .arrow {
	transition: transform 0.3s;
	color: #999;
}
.help-q .arrow.up {
	transform: rotate(180deg);
}
.help-a {
	padding: 15px;
	background: #fff;
	line-height: 1.8;
	color: #606266;
	font-size: 14px;
}
.help-a p {
	margin: 0;
}
@media (max-width: 768px) {
	.help-content {
		padding: 10px;
	}
	.help-section-title {
		font-size: 16px;
	}
	.help-q {
		padding: 12px 10px;
	}
	.help-q span {
		font-size: 13px;
	}
	.help-a {
		padding: 12px 10px;
		font-size: 13px;
	}
}
</style>
